'use client';

import { type RefObject, useEffect, useRef } from 'react';

/** Calls `onOutside` for a pointer press outside `ref` while `active`. The
 *  popover is a DOM descendant of `ref`, so presses inside it count as inside. */
export function useOutsidePointerDown(active: boolean, ref: RefObject<HTMLElement | null>, onOutside: () => void) {
    const onOutsideRef = useRef(onOutside);

    useEffect(() => {
        onOutsideRef.current = onOutside;
    });

    useEffect(() => {
        if (!active) return;

        const handlePointerDown = (event: PointerEvent) => {
            if (!ref.current?.contains(event.target as Node)) onOutsideRef.current();
        };

        document.addEventListener('pointerdown', handlePointerDown, true);

        return () => document.removeEventListener('pointerdown', handlePointerDown, true);
    }, [active, ref]);
}
